import { PAGE_TYPE } from "@/meta/common";
import { RouteRecordRaw } from "vue-router";
import { defineAsyncComponent } from "vue";
import { useUserStore } from "@/stores/modules/user.ts";
/**
 * 仓储管理
 */
export const warehouseStorageRouter: RouteRecordRaw[] = [
    {
        path: "warehouseStorage",
        name: "WarehouseStorage",
        component: () => import("@/views/layouts/index.vue"),
        redirect: "/warehouseStorage/inventoryQuery",
        meta: {
            title: "仓储管理"
        },
        children: [
            {
                path: "inventoryQuery",
                name: "WarehouseInventoryQuery",
                component: defineAsyncComponent(() => {
                    const userStore = useUserStore();
                    if (userStore?.isSAAS) {
                        return import("@/views/components/emptyPage/index.vue");
                    } else {
                        return import("@/views/pages/warehouseSupervision/storageManagement/inventoryQuery/index.vue");
                    }
                }),
                meta: {
                    title: "库存查询",
                    pageType: PAGE_TYPE.LIST.code,
                    isNotShowHeader: true,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_S_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_S_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_S_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "warehouseDistribution",
                name: "WarehouseDistribution",
                component: () => import("@/views/pages/warehouseSupervision/storageManagement/inventoryQuery/distribution.vue"),
                meta: {
                    title: "库存分布",
                    isNotShowHeader: true,
                    hidden: true,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_S_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_S_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_S_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "warehouseInbound",
                name: "WarehouseInbound",
                component: defineAsyncComponent(() => {
                    const userStore = useUserStore();
                    if (userStore?.isSAAS) {
                        return import("@/views/components/emptyPage/index.vue");
                    } else {
                        return import("@/views/pages/warehouseSupervision/storageManagement/inboundManagement/index.vue");
                    }
                }),
                meta: {
                    title: "入库管理",
                    activeMenu: "WarehouseInbound",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_S_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_S_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_S_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "warehouseInbound/detail",
                name: "WarehouseInboundDetail",
                component: () => import("@/views/pages/warehouseSupervision/storageManagement/inboundManagement/detail.vue"),
                meta: {
                    title: "入库单详情",
                    activeMenu: "WarehouseInbound",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    hidden: true,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_S_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_S_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_S_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "warehouseOutbound",
                name: "WarehouseOutbound",
                component: defineAsyncComponent(() => {
                    const userStore = useUserStore();
                    if (userStore?.isSAAS) {
                        return import("@/views/components/emptyPage/index.vue");
                    } else {
                        return import("@/views/pages/warehouseSupervision/storageManagement/outboundManagement/index.vue");
                    }
                }),
                meta: {
                    title: "出库管理",
                    isNotShowHeader: true,
                    activeMenu: "WarehouseOutbound",
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_S_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_S_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_S_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "warehouseOutbound/detail",
                name: "WarehouseOutboundDetail",
                component: () => import("@/views/pages/warehouseSupervision/storageManagement/outboundManagement/detail.vue"),
                meta: {
                    title: "出库单详情",
                    activeMenu: "WarehouseOutbound",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    hidden: true,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_S_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_S_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_S_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "WarehousestockTake",
                name: "warehouseStockTake",
                component: defineAsyncComponent(() => {
                    const userStore = useUserStore();
                    if (userStore?.isSAAS) {
                        return import("@/views/components/emptyPage/index.vue");
                    } else {
                        return import("@/views/pages/warehouseSupervision/storageManagement/stocktakeManagement/index.vue");
                    }
                }),
                meta: {
                    title: "盘点管理",
                    activeMenu: "warehouseStockTake",
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_S_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_S_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_S_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "warehouseStockTake/detail",
                name: "WarehouseStockTakeDetail",
                component: () => import("@/views/pages/warehouseSupervision/storageManagement/stocktakeManagement/detail.vue"),
                meta: {
                    title: "盘点详情",
                    activeMenu: "warehouseStockTake",
                    isNotShowHeader: true,
                    hidden: true,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_S_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_S_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_S_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "warehouseStockTake/add",
                name: "WarehouseStockTakeAdd",
                component: () => import("@/views/pages/warehouseSupervision/storageManagement/stocktakeManagement/form.vue"),
                meta: {
                    title: "新增盘点",
                    activeMenu: "warehouseStockTake",
                    isNotShowHeader: true,
                    hidden: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_S_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "warehouseStockTake/edit",
                name: "WarehouseStockTakeEdit",
                component: () => import("@/views/pages/warehouseSupervision/storageManagement/stocktakeManagement/form.vue"),
                meta: {
                    title: "修改盘点",
                    activeMenu: "warehouseStockTake",
                    isNotShowHeader: true,
                    hidden: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_S_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "inventoryRandomInspection",
                name: "WarehouseInventoryRandomInspection",
                component: defineAsyncComponent(() => {
                    const userStore = useUserStore();
                    if (userStore?.isSAAS) {
                        return import("@/views/components/emptyPage/index.vue");
                    } else {
                        return import("@/views/pages/warehouseSupervision/storageManagement/inventoryRandomInspection/index.vue");
                    }
                }),
                meta: {
                    title: "库存抽检",
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_S_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_S_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_S_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "inventoryRandomInspection/detail/:id",
                name: "WarehouseInventoryRandomInspectionDetail",
                component: () =>
                    import("@/views/pages/warehouseSupervision/storageManagement/inventoryRandomInspection/detail.vue"),
                meta: {
                    title: "抽检详情",
                    activeMenu: "WarehouseInventoryRandomInspection",
                    pageType: PAGE_TYPE.LOG.code,
                    hidden: true,
                    isNotShowHeader: true,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_S_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_S_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_S_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "inventoryRandomInspection/add",
                name: "WarehouseInventoryRandomInspectionAdd",
                component: () =>
                    import("@/views/pages/warehouseSupervision/storageManagement/inventoryRandomInspection/form.vue"),
                meta: {
                    title: "新增抽检单",
                    activeMenu: "WarehouseInventoryRandomInspection",
                    isNotShowHeader: true,
                    hidden: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_S_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "inventoryRandomInspection/edit/:id",
                name: "WarehouseInventoryRandomInspectionEdit",
                component: () =>
                    import("@/views/pages/warehouseSupervision/storageManagement/inventoryRandomInspection/form.vue"),
                meta: {
                    title: "修改抽检单",
                    activeMenu: "WarehouseInventoryRandomInspection",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    hidden: true,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_S_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "warehouseTransfer",
                name: "WarehouseTransfer",
                component: defineAsyncComponent(() => {
                    const userStore = useUserStore();
                    if (userStore?.isSAAS) {
                        return import("@/views/components/emptyPage/index.vue");
                    } else {
                        return import("@/views/pages/warehouseSupervision/transferManagement/index.vue");
                    }
                }),
                meta: {
                    title: "过户管理",
                    activeMenu: "WarehouseTransfer",
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_S_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_S_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_S_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "warehousetransfer/detail/:id",
                name: "WarehouseTransferDetail",
                component: () => import("@/views/pages/warehouseSupervision/transferManagement/detail.vue"),
                meta: {
                    title: "过户详情",
                    activeMenu: "WarehouseTransfer",
                    hidden: true,
                    isNotShowHeader: true,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_S_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_S_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_S_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "storagePledge",
                name: "StoragePledgeManagement",
                component: defineAsyncComponent(() => {
                    const userStore = useUserStore();
                    if (userStore?.isSAAS) {
                        return import("@/views/components/emptyPage/index.vue");
                    } else {
                        return import("@/views/pages/warehouseSupervision/pledgeManagement/index.vue");
                    }
                }),
                meta: {
                    title: "质押管理",
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_S_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_S_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_S_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "storagePledge/detail/:id",
                name: "StoragePledgeDetail",
                component: () => import("@/views/pages/warehouseSupervision/pledgeManagement/detail.vue"),
                meta: {
                    title: "质押详情",
                    activeMenu: "StoragePledgeManagement",
                    pageType: PAGE_TYPE.LOG.code,
                    hidden: true,
                    isNotShowHeader: true,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_S_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_S_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_S_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "storagePledge/add",
                name: "StoragePledgeAdd",
                component: () => import("@/views/pages/warehouseSupervision/pledgeManagement/add.vue"),
                meta: {
                    title: "新增质押",
                    activeMenu: "StoragePledgeManagement",
                    isNotShowHeader: true,
                    hidden: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_S_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "storagePledge/edit/:id",
                name: "StoragePledgeEdit",
                component: () => import("@/views/pages/warehouseSupervision/pledgeManagement/add.vue"),
                meta: {
                    title: "变更质押",
                    activeMenu: "StoragePledgeManagement",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    hidden: true,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_S_PROJECT_DEAL"
                        }
                    ]
                }
            },
            // 仓储费用
            {
                path: "storageFee",
                name: "WarehouseStorageFee",
                component: defineAsyncComponent(() => {
                    const userStore = useUserStore();
                    if (userStore?.isSAAS) {
                        return import("@/views/components/emptyPage/index.vue");
                    } else {
                        return import("@/views/pages/warehouseSupervision/storageManagement/storageFee/index.vue");
                    }
                }),
                meta: {
                    title: "仓储费用",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_S_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_S_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_S_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "storageInception",
                name: "WarehouseStorageInception",
                component: defineAsyncComponent(() => {
                    const userStore = useUserStore();
                    if (userStore?.isSAAS) {
                        return import("@/views/components/emptyPage/index.vue");
                    } else {
                        return import("@/views/pages/warehouseSupervision/storageInception/index.vue");
                    }
                }),
                meta: {
                    title: "仓储期初",
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_S_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_S_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_S_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "storageInception/detail/:id",
                name: "WarehouseStorageInceptionDetail",
                component: () => import("@/views/pages/warehouseSupervision/storageInception/detail.vue"),
                meta: {
                    title: "仓储期初详情",
                    activeMenu: "WarehouseStorageInception",
                    pageType: PAGE_TYPE.LOG.code,
                    hidden: true,
                    isNotShowHeader: true,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_S_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_S_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_S_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "storageInception/add",
                name: "WarehouseStorageInceptionAdd",
                component: () => import("@/views/pages/warehouseSupervision/storageInception/add.vue"),
                meta: {
                    title: "新增仓储期初",
                    activeMenu: "WarehouseStorageInception",
                    isNotShowHeader: true,
                    hidden: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_S_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "storageInception/edit/:id",
                name: "WarehouseStorageInceptionEdit",
                component: () => import("@/views/pages/warehouseSupervision/storageInception/add.vue"),
                meta: {
                    title: "修改仓储期初",
                    activeMenu: "WarehouseStorageInception",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    hidden: true,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_S_PROJECT_DEAL"
                        }
                    ]
                }
            }
        ]
    }
];
